import axios from 'axios';

export const DeleteMediaMixin = {
  methods: {
    deleteMedia(url) {
      return new Promise((resolve, reject) => {
        let msg = this.$t('DeleteMediaMixin.deleting-this-item-will-also-delete-any-uploaded-files-or-videos-associated-with-it-are-you-sure-you');

        this.showConfirmPrompt(
          () => {
            // go to network page if belongs to one network - else go to networks
            axios
              .delete(url)
              .then(() => {
                resolve();
              })
              .catch(() => {
                reject();
              });
          },
          msg,
          'DELETE'
        );
      });
    },
  },
};
